
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services/base-http-req-resp.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { CommonService } from '../../question/services/commonservice';
import {
  User,
  Role,
  Company,
  ServiceLine,
  Survey,
  SaveUserResponse,
  MailContent
} from '../models/user.model';

@Injectable()
export class UserService extends BaseHttpReqRespService {
  myAppUrl: any;
  USER_ENDPOINT = API_ENDPOINTS.USER;

  constructor(
    http: HttpClient,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private EncrDecr: EncrDecrService,
    private commonService: CommonService,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }

  // ── GET: User list (detailed) ──────────────────────────────
  getUserListDetails(workspaceId: string): Observable<User[]> {
    debugger;
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.LIST_DETAILS}?workspaceId=${workspaceId}`
    );
  }

  // ── GET: Roles ─────────────────────────────────────────────
  getRoles(): Observable<Role[]> {
    debugger;
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.ROLES}`
    );
  }

  // ── GET: Companies ─────────────────────────────────────────
  getCompanies(workspaceId: string): Observable<Company[]> {
    debugger;;
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.COMPANIES}?workSpaceId=${workspaceId}`
    );
  }

  // ── GET: Service lines ─────────────────────────────────────
  getServiceLines(): Observable<ServiceLine[]> {
    debugger;
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.SERVICE_LINES}`
    );
  }

  // ── GET: Surveys by service line ───────────────────────────
  getSurveysByServiceLine(serviceLineId: number): Observable<Survey[]> {
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.SURVEYS}?serviceLineId=${serviceLineId}`
    );
  }

  // ── GET: Edit user by ID ───────────────────────────────────
  editUser(userId: number): Observable<User> {
    return this.commonService.httpGet(
      '',
      `${this.myAppUrl}/${this.USER_ENDPOINT.EDIT}?userId=${userId}`
    );
  }

  // ── POST: Save user ────────────────────────────────────────
  saveUser(model: any): Observable<SaveUserResponse> {
    debugger;
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    const url = `${this.myAppUrl}/${this.USER_ENDPOINT.SAVE}`;
    return this.http.post<SaveUserResponse>(url, model, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: { workspaceId }
    });
  }

  // ── POST: Delete user ──────────────────────────────────────
  deleteUser(userId: number, workspaceId: string): Observable<User[]> {
    const url = `${this.myAppUrl}/${this.USER_ENDPOINT.DELETE}?userId=${userId}&isActive=false&workSpaceid=${workspaceId}`;
    return this.http.post<User[]>(url, '', {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    });
  }

  // ── POST: Get email template ───────────────────────────────
  getEmailTemplate(workspaceId: string): Observable<MailContent> {
    return this.http.post<MailContent>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.EMAIL_TEMPLATE}`,
      '',
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8' }),
        params: { workspaceId }
      }
    );
  }

  // ── POST: Send newsletter ──────────────────────────────────
  sendNewsletter(formData: FormData, subject: string, fileName: string, message: string): Observable<any> {
    return this.http.post<any>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.SEND_NEWSLETTER}`,
      formData,
      {
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        params: { subject, fileName, message }
      }
    );
  }

  // ── POST: Master user list (for export) ────────────────────
  getMasterUserList(workspaceId: string): Observable<any[]> {
    return this.http.post<any[]>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.MASTER_LIST}?workSpaceId=${workspaceId}`,
      '',
      { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    );
  }

  // ── POST: Save Okta user ───────────────────────────────────
  saveOktaUser(model: any): Observable<string> {
    debugger;
    return this.http.post<string>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.OKTA_SAVE}`,
      model,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        })
      }
    );
  }

  // ── POST: Activate Okta user ───────────────────────────────
  activateOktaUser(model: any): Observable<string> {
    return this.http.post<string>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.OKTA_ACTIVATE}`,
      model,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        })
      }
    );
  }

  // ── POST: Save bulk users ──────────────────────────────────
  saveBulkUsers(model: any): Observable<any> {
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    return this.http.post<any>(
      `${this.myAppUrl}/${this.USER_ENDPOINT.BULK_SAVE}`,
      model,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8' }),
        params: { workspaceId }
      }
    );
  }
}
